/**
 * @file
 * Example of a custom script file.
 */

(($, Drupal) => {
  Drupal.behaviors.GDSCustomGlobal = {
    attach: (context, settings) => {
      /* Added section ids for sticky navigation jumplinks */
      $("div.grandes-premio-section").attr('id', 'premios');
      $("div.inscribete-ahora-heading").attr('id', 'inscripciones');
      $("div.agenda-y-horarios-tabs").attr('id', 'agenda');
      $("div.retos-content").attr('id', 'retos');
      /* Updated external link button */
      setTimeout(function () {
        if ($('div.ui-dialog .gds-modal__actions button.external-confirm').length) {
          $('div.ui-dialog .gds-modal__actions button.external-confirm').attr({
            title: 'Proceder',
            alt: 'Proceder',
            'aria-label': 'Proceder'
          });
        }
      }, 500);
      /* Remove space after opening quote and before closing quote */
      $('.gds-testimonial__content blockquote').each(function () {
        let text = $(this).text();
        text = text.replace(/“\s+/, '“').replace(/\s+”/, '”');
        $(this).text(text);
      });
      /* Removed href and cursor pointer from testimonial card link */
      $(".comentarios-testimonial .gds-testimonial--card").each(function () {
        $(this).find("a").removeAttr('href').css({
          'cursor': 'default',
          'pointer-events': 'none'
        });
      });
      /* Solution : Jumplink Visibility Issue with Sticky Nav  - Start */
      // Handle direct URL hash
      function scrollToHash(hash) {
          const target = document.querySelector(hash);
          const nav = document.querySelector('.gds-header__main-container');
          if (!target) {
              return;
          }
          const offset = nav ? nav.offsetHeight : 0;
          function keepScrolling() {
              const targetTop = target.getBoundingClientRect().top;
              // Stop when target reaches expected position
              if (Math.abs(targetTop - offset) <= 10) {
                  return;
              }
              window.scrollTo({
                  top: window.scrollY + (targetTop - offset),
                  behavior: 'smooth'
              });
              setTimeout(keepScrolling, 300);
          }
          keepScrolling();
      }
      const initialHash = window.location.hash;
      if (initialHash) {
          // Prevent native browser hash jump
          history.replaceState( null, '', window.location.pathname + window.location.search );
          window.addEventListener('load', function () {
              setTimeout(function () {
                  history.replaceState( null, '', window.location.pathname + window.location.search + initialHash );
                  scrollToHash(initialHash);
              }, 1500);
          }, { once: true });
      }
      $(".retos-content .gds-content-block .gds-cell--m-half:eq(1) .gds-paragraph--caption-l").text("RETO 2");
      $("nav#gds-mega-nav-0 a.main-link").off("click").on("click", function(event) {
        const href = $(this).attr('href');
        if (!href || href.indexOf('#') === -1) {
            return;
        }
        const hash = '#' + href.split('#')[1];
        const currentSlug = window.location.pathname.split('/').filter(Boolean).pop();
        const linkSlug = this.pathname.split('/').filter(Boolean).pop();
        if (currentSlug === linkSlug) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            history.replaceState(null,'',window.location.pathname + window.location.search);
            $('.gds-header .mobilemenutoggle').trigger('click');
            setTimeout(() => {
                scrollToHash(hash);
                history.replaceState(null,'',window.location.pathname + window.location.search + hash);
            }, 300);
            return false;
        }
      });
      /* Solution : Jumplink Visibility Issue with Sticky Nav  - End */
    },
  };
})(jQuery, Drupal);